import { go, sel } from 'fxjs/es';

export const makeImageIdToSvgUrl = (image_id) => {
  return go($.get('/@api/svg_images_images/svg_from_image', { image_id }), sel('url'));
};
